/**
 * 账本相关的 TanStack Query Hooks
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { getBillingRecordList } from '@/services/billingService'
import type { BillingRecord, BillingRecordListParams } from '@/types/billing'

/** 账本查询 Key */
const BILLING_RECORDS_QUERY_KEY = ['billing', 'records'] as const

/**
 * 分页账本查询结果
 */
export interface BillingRecordsResult {
  records: BillingRecord[]
  total: number
  page: number
  pageSize: number
}

/**
 * 获取分页账本的 Hook
 * @param params 查询参数
 * @param enabled 是否启用查询
 * @returns 查询结果
 */
export function useBillingRecordsPaginated(
  params?: BillingRecordListParams,
  enabled = true
): UseQueryResult<BillingRecordsResult> {
  return useQuery({
    queryKey: [...BILLING_RECORDS_QUERY_KEY, params] as const,
    queryFn: async (): Promise<BillingRecordsResult> => {
      const data = await getBillingRecordList(params)
      return {
        records: data.list,
        total: data.total,
        page: data.page,
        pageSize: data.page_size,
      }
    },
    enabled,
  })
}

export { BILLING_RECORDS_QUERY_KEY }
